import {Action} from "@ngrx/store";

export const TOGGLE_AI_SIDEBAR: string = '[AiSidebar] Toggle Ai Sidebar';

export class ToggleAiSidebar implements Action {

  readonly type: string = TOGGLE_AI_SIDEBAR;

}

export type AiSidebarAction = ToggleAiSidebar;
